import { MEMBERSHIP_MODAL_STEPS } from 'src/modules/Modals/constants'

export function ActiveFooter({ onContinue }) {
  return (
    <div className="footer-container">
      <span
        className="cancel"
        onClick={() => onContinue(MEMBERSHIP_MODAL_STEPS.cancel)}>
        Cancel Unity Pass
      </span>
    </div>
  )
}
